module.exports = __webpack_public_path__ + "static/media/casino.25a04975.jpg";